import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("olivara_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const fileUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${API}/files/${path}`;
};

// Re-export locale-aware helpers so existing imports keep working.
// Components that need to react to language changes should import `useTranslation`
// and pass `i18n.language` to these helpers.
export { formatPrice, formatDate, formatDateTime, formatNumber, localized, convertPrice, currencyForLang, apiError, initFxRate } from "./locale";
